// extracted by mini-css-extract-plugin
module.exports = {"infoList":"useReviewGuideBottomSheet_infoList__3LMyk","infoItem":"useReviewGuideBottomSheet_infoItem__CSDDC","infoItemText":"useReviewGuideBottomSheet_infoItemText__opUxY"};